export default "__VITE_ASSET__eQnppdKp__"